const isProd = process.env.REACT_APP_ENV === 'production';

const DEV_URL = 'https://api-dev.nextorder.co/';

const PROD_URL = 'https://api.nextorder.co/';

export const API_URL = isProd ? PROD_URL : DEV_URL;
